// Words for heroes.py and best_signal.py output (GRO-275). Pure, so node --test can load it.
import type { AccountSignal, BookAccount, Hero } from '../api/types';
import { contactDisplayName } from '../lib/contactName.ts';

const SIGNAL_LABELS: Record<string, string> = {
  playground_user: 'playground user',
  org_admin: 'org admin',
  replied: 'replied',
  warm_path: 'warm path',
  in_sequence: 'in a sequence',
  job_changer: 'job changer',
};

// A contact-level signal kind as a chip label; an unknown kind reads as itself.
export function contactSignalLabel(kind: string): string {
  return SIGNAL_LABELS[kind] ?? kind.replace(/_/g, ' ');
}

// Who the hero is, for a heading: name, else one read off a first.last address, else the
// address, else a placeholder. The same rule as every other people surface (contactName.ts).
export function heroName(hero: Hero): string {
  return contactDisplayName(hero.name, hero.email, 'Unknown person');
}

// The best hero and the rest, in the server's order. Nothing is re-ranked here.
export function splitHeroes(row: BookAccount): { best: Hero | null; rest: Hero[] } {
  const heroes = row.heroes ?? [];
  return { best: heroes[0] ?? null, rest: heroes.slice(1) };
}

// The headline signal is the quotable one; the rest follow in score order, without repeats.
export function splitSignals(row: BookAccount): {
  best: AccountSignal | null; timing: AccountSignal | null; rest: AccountSignal[];
} {
  const signals = row.signals ?? [];
  const best = row.best_quotable_signal ?? signals[0] ?? null;
  const timing = row.best_timing_signal ?? null;
  const shown = new Set([best?.fact, timing?.fact]);
  return { best, timing, rest: signals.filter(signal => !shown.has(signal.fact)) };
}
